
import config from 'config'

import useApiRouter from './apiRouter'
import appRouter from './appRouter'
// import ErrorBoundary from './ErrorBoundary'

const C = {

  addOpts: [
    { label: 'Select...',  value: null },
    { label: 'Header',     value: 'H3' }, // [ref-h3]
    { label: '<blank line>', value: 'BR' }, // [ref-br]
  ],

  asc: 'asc',
  desc: 'desc',

  bankTabs: {
    contacts: 'contacts',
    schedules: 'schedules',
  },

  classes: {
    sidebarIsOpen:   'is-open',
    sidebarIsClosed: 'is-closed',
  },

  el: {
    br: 'BR', // [ref-br]
    h3: 'H3', // [ref-h3]
  },

  fedfisCustomerId: 8769,

  fontSizeOpts: [
    { label: '10', value: 10 },
    { label: '12', value: 12 },
    { label: '14', value: 14 },
    { label: '16', value: 16 },
  ],

  formatOpts: [
    { label: 'csv', value: 'csv' },
    { label: 'pdf', value: 'pdf' },
    { label: 'web', value: 'web' },
  ],
  formats: {
    csv: 'csv',
    pdf: 'pdf',
    web: 'web',
  },

  itemsPerRowOpts: [
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ],

  kinds: {
    AdvancedReport: 'AdvancedReport',
    AdvancedReport_financials: 'AdvancedReport-Financials',
    AdvancedReport_fintegration: 'AdvancedReport-Fintegration',
    List: 'list',
    Query: 'query', // to change this, change backend first!
    Report: 'Report',
  },

  actions: {
    'banks#contacts': 'banks#contacts',
    'banks#results': '/banks/results',
    'banks#schedule': 'banks#schedule',
    'docs#show': 'docs#show',
  },
  lists_actions: {
    add_to_existing: 'add-to-existing',
    add_to_new: 'add-to-new',
    remove_from_existing: 'remove-from-existing',
    rename: 'query-rename', // @deprecated, use queries_actions.rename
    modify: 'list-modify',
  },
  queries_actions: {
    create: 'query-create',
    modify: 'query-modify',
    rename: 'query-rename',
    run:    'query-run',
  },
  reports_actions: {
    rename: 'reports-rename',
  },


  missing_image: '//d15g8hc4183yn4.cloudfront.net/wp-content/uploads/2023/11/22165732/250x250-fedfis-greyout-3.jpg',

  /* O */

  // operators
  op: {
    any_of: 'any-of',
    between: 'between',
    bool: 'yesno',
    // deprecated, use toggle.
    // this is a trick. instead of `'true'`, `'false'` the true value disappears!
    bool_inv: 'noyes',
    csid: 'csid',
    match_exact: 'match-exact',
    match_i: 'match-i',
    multiselect_checkboxes: 'multiselect-checkboxes',
    multiselect_select2: 'multiselect-select2',
    search_range: 'search-range-1',
    text_field: 'match-i', // comma-separated; exact; insensitive
    toggle: 'toggle',
    top_100: 'top-100',
    total_assets: 'total-assets',
    // select2: 'select2',
  },

  /* R */

  roles: {
    FINTEGRATION: 'Fintegration - All',
    FINTEGRATION_FDV: 'Fintegration - FDV Only',
    INTERNAL: 'Internal',
  },

  /* S */

  scope: {
    company: 'company',
    default: { 'mine': true, 'standard': true, 'company': true, 'shared': true },
    mine: 'mine',
    shared: 'shared',
    standard: 'standard',
  },

  /* From: https://stackoverflow.com/questions/54218351/changing-height-of-react-select-component */
  select2Styles: {
    control: (provided, state) => ({
      ...provided,

      // background: 'var(--fff-bg-color)',
      background: 'var(--fff-input-bg-color)',

      // border: '1px solid var(--fff-secondary-emphasis-color)',
      border: '1px solid var(--fff-text-color)',

      color: 'var(--fff-text-color)',
      minWidth: '20em',
      // minHeight: '3.5em',
      // height: '3.5em',

      // boxShadow: state.isFocused ? null : null,
      // boxShadow: '0px 0px 6px red',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(--fff-bg-color)',
      ':hover': {
        backgroundColor: 'var(--fff-primary-bg-color)',
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      // height: '3.5em',
      padding: '0 6px',
      // border: '1px solid red',
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px',
      // border: '1px solid blue',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      // height: '3.5em',
      // border: '1px solid green',
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(--fff-bg-color)',

      // border: '1px solid var(--fff-secondary-emphasis-color)',
      border: '1px solid var(--fff-text-color)',

      color: 'var(--fff-text-color)',
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: 'var(--fff-text-color)',
    }),
  },

  sortNumber: 'sort-number',
  sortString: 'sort-string',


  thirds: {
    bySchedule: 'by-schedule',
    byKeyword: 'by-keycoard',
    addExtra: 'add-extra',
  },

}

const logg = (a, b="", c=null) => {
  if ('test' === config.env_name) { return }
  if ('undefined' === typeof window) { return }
  c = "string" === typeof c ? c : b.replace(/\W/g, "");
  if (c.length > 0) { window[c] = a; }
  console.log(`+++ ${b}:`, a); // eslint-disable-line no-console
};

const loggt = (a, b="", c=null) => {
  if ('test' !== config.env_name) { return }
  if ('undefined' === typeof window) { return }
  c = "string" === typeof c ? c : b.replace(/\W/g, "");
  if (c.length > 0) { window[c] = a; }
  console.log(`+++t ${b}:`, a); // eslint-disable-line no-console
};

const defaultSearchRangeValue = {
  ubpr_code: null,
  period: null,
  op_1: 'min',
  val_1: '',
  op_2: 'max',
  val_2: '',
}

const defaultBanksQueryTmpl = {
  // 'clauses': {},

  'search-range.1': { operator: C.op.search_range, value: defaultSearchRangeValue },
  'search-range.2': { operator: C.op.search_range, value: defaultSearchRangeValue },
  'search-range.3': { operator: C.op.search_range, value: defaultSearchRangeValue },
  'search-range.4': { operator: C.op.search_range, value: defaultSearchRangeValue },
  'search-range.5': { operator: C.op.search_range, value: defaultSearchRangeValue },

  'tbl_Bank.Bank_Authority_Charter_ID': { operator: C.op.any_of, value: [] },
  'tbl_Bank.Bank_Cert': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_Charter_Type_ID': { operator: C.op.any_of, value: [] },
  'tbl_Bank.Bank_City': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_County': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_MSA_ID': { operator: C.op.any_of, value: [] },
  'tbl_Bank.Bank_Name': { operator: C.op.match_i, value: '' },
  'tbl_Bank.Bank_Open_Flag': { operator: C.op.toggle, value: '1' },
  'tbl_Bank.Bank_RSSD': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_State': { operator: C.op.any_of, value: [] },
  'tbl_Bank.Bank_THC_Number': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_Ticker': { operator: C.op.csid, value: '' },
  'tbl_Bank.Bank_Top_Filer_Flag': { operator: C.op.top_100, value: false },
  'tbl_Bank.Bank_Trading_Status': { operator: C.op.any_of, value: [] },

  'View_Bank_Total_Assets.Total_Assets': { operator: C.op.between, value: [ '', '' ] },
}
Object.freeze(defaultBanksQueryTmpl)

const defaultFintegrationQueryTmpl = {

  'fintegration.ATM_Network': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Bill_Pay_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Business_Online_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Check_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Commercial_LOS': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Content_Management_System': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Core_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Credit_Card_Issuer': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Credit_Card_Type': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Credit_Processor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Debit_Card_Type': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Debit_Processor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Merchant_Services_Processor': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Mobile_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Online_Auto_Loan_Origination_System': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Online_Mortgage_Loan_Origination_System': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Online_New_Account_Opening': { operator: C.op.multiselect_checkboxes, value: {} },
  'fintegration.Online_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.P2P_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Rewards': { operator: C.op.multiselect_checkboxes, value: {} },

  'fintegration.Web_Live_Chat_Vendor': { operator: C.op.multiselect_checkboxes, value: {} },

  'View_Bank_Total_Assets.Total_Assets': { operator: C.op.between, value: [ '', '' ] },
}
Object.freeze(defaultFintegrationQueryTmpl)

/**
 * Number.prototype.format(n, x, s, c)
 * From: https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-strings
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
 Number.prototype.format = function(n, x, s, c) { // eslint-disable-line no-extend-native
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};


const mockFetch = async (url) => {
  logg(url, 'mockFetch')

  if (url === `${config.apiOrigin}/periods.json?jwt_token=some-token`) {
    return {
      ok: true,
      status: 200,
      json: async () => ({ hello: 'world' }),
    }
  } else if (url === `${config.apiOrigin}/states.json?jwt_token=some-token`) {
    return {
      ok: true,
      status: 200,
      json: async () => {
        return [{ abbr: 'VI', name: 'Virgin Islands', region: 'Territories' }]
      },
    }
  } else {
    // return fetch(url)
    throw new Error(`Unhandled request: ${url}`);
  }
}

export {
  appRouter,
  C,
  defaultBanksQueryTmpl,
  defaultFintegrationQueryTmpl,
  defaultSearchRangeValue,
  // ErrorBoundary,
  logg,
  loggt,
  useApiRouter,
}
